"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var ConditionalDisplay_1 = __importDefault(require("../../Mixins/ConditionalDisplay"));
var PredicateInput_1 = __importDefault(require("../../Mixins/PredicateInput"));
var SourceValue_1 = __importDefault(require("../../Mixins/SourceValue"));
exports.default = vue_1.default.extend({
    props: ['name', 'label', 'required', 'placeholder'],
    mixins: [ConditionalDisplay_1.default, PredicateInput_1.default, SourceValue_1.default],
    data: function () {
        var model = this.$root.$data;
        return {
            readonly: model.readOnly
        };
    },
    mounted: function () {
        var $input = $(this.$refs.pickerTime);
        var $icon = $(this.$refs.icon);
        var eventIcon = function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $input.data("DateTimePicker").toggle();
        };
        $input.datetimepicker({
            locale: 'fr',
            format: 'LT'
        })
            .on("dp.hide", function () {
            setTimeout(function () {
                $icon.one('click', eventIcon);
            }, 300);
        })
            .on("dp.show", function () {
            $icon.off();
        });
        $icon.one('click', eventIcon);
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/DatepickerTime.vue
// module id = 188
// module chunks = 0